const sortAndFilterDefaultStatuses = (statusesFromPlotNumbers, defaultStatuses) => statusesFromPlotNumbers.filter((status, index, statuses) => index === statuses.findIndex(statusAdded => statusAdded.value === status.value)).sort((a, b) => {
	const statusValues = defaultStatuses.map(status => status.value);
	if (statusValues.indexOf(a.value) < statusValues.indexOf(b.value)) {
		return -1;
	}
	if (statusValues.indexOf(a.value) > statusValues.indexOf(b.value)) {
		return 1;
	}
	return 0;
});

const areThereDefaultHighLightedPlotsOnTheActiveView = (plotNumbers, activeView, defaultStatuses) => {
	const idsOnActiveView = activeView.shapes.map(shape => shape.id);
	const highLightedStatuses = defaultStatuses.filter(status => status.isSelected).map(status => status.value);
	return plotNumbers.filter(plot => idsOnActiveView.indexOf(plot.id) >= 0).filter(plot => highLightedStatuses.indexOf(plot.status.value) >= 0).length > 0;
};

export {
	sortAndFilterDefaultStatuses,
	areThereDefaultHighLightedPlotsOnTheActiveView
};